import { IAxiosResponse } from "../../axiosTypes";

export const invalidAgentIDMessage = 'Please enter a valid Agent ID';

export const agentIsInactive = (data: IAxiosResponse) => {
  if(!data || !data.data) return true;

  return JSON.parse(data.data).ACTIVE !== 1
}
export const isInvalidAgentLogin = (data: IAxiosResponse ) => {
  if (
    data.isAxiosError ||
    data.status !== 200 ||
    agentIsInactive(data)
  ) { return true; }
  else {
    return false;
  }
}

export const validAgentId = (agentId: any) => {
  if(!agentId) return false

  return !isNaN(parseInt(agentId))
}